import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  min-width: 1020px;

  background: #eee;


  position: relative;
`;

export const ExportButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  background: #40e5a0;
  border-radius: 0.35296625rem;
  padding: 0.794375rem 1.765rem;
  box-shadow: 0px 0.235310625rem 0.8824125rem rgba(64, 229, 160, 0.41);
  margin-right: 3.625rem;
  cursor: pointer;
  svg {
    height: 0.9375rem;
  }

  span {
    margin-left: 0.43125rem;
    font-size: 0.7062rem;
    font-family: Sora;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.2rem 2rem 0 0;
  align-items: center;
  height:  3rem;
`;

export const Body = styled.div`
  display: flex;
  height: 40%;
  margin-top: 0.5rem;
  margin-left: 1rem;
  margin-right: 1rem;

`;
export const Footer = styled.div`
  height: 40%;
  margin-left: 1rem;
  margin-right: 1rem;
`;
